var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-wrapper",class:{
    'icon-wrapper_disabled': _vm.disabled
  },style:(_vm.iconStyles)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }